import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { AssetDocumentZone, PendingDocumentMove } from "../../../../../api/ClientFileApi";
import { ClientFileQueryKey } from "../../../../../query/clientFileQueryKeys";
import { AssetDocumentsSection } from "../../../../components/asset-documents-section/AssetDocumentsSection";
import { useAssetInventoryDocuments } from "../../../../hooks/useAssetInventoryDocuments";
import { AssetIncomeFormValues } from "../../IncomeView.types";

const SECTION = "clients.client.debtSettlement.assetInventory.incomeTab.proofs";

interface Props {
  clientId: string;
  formik: FormikProps<AssetIncomeFormValues>;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function IncomeProofsSection({ clientId, formik, onAddMove, onCancelMove }: Props) {
  const { t } = useTranslation();
  const { documents, markRead, deleteDocument, isBusy } = useAssetInventoryDocuments(clientId, {
    queryKey: ClientFileQueryKey.AssetInventoryIncomeProofs,
    getDocuments: (api, params) => api.getAssetInventoryIncomeProofs(params),
    getDeleteDocument: (api) => api.deleteAssetInventoryIncomeProof.bind(api),
  });

  return (
    <AssetDocumentsSection
      clientId={clientId}
      formik={formik}
      fieldName="incomeProofs"
      zone={AssetDocumentZone.Income}
      title={t(`${SECTION}.title`)}
      uploadHint={t(`${SECTION}.uploadHint`)}
      documents={documents}
      onMarkRead={markRead}
      onDelete={deleteDocument}
      isBusy={isBusy}
      onAddMove={onAddMove}
      onCancelMove={onCancelMove}
    />
  );
}
